import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { eventProfilePageConfig } from "./eventProfilePageConfig";

export const eventProfileRecordDefinition: RecordDefinition = {
  path: "/event-profile",
  entityName: "dweventprofile",
  listRoute: "/event-profiles",
  backTitle: "Back to event profiles",
  allowedRoles: administratorRoles,
  config: eventProfilePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Event Profile",
    newRecordTitle: "New Event Profile",
  },
};
